import React, { useEffect, useState } from 'react';
import Breadcumb from '../../Layouts/Breadcumb'
import DashboardNav from './DashboardNav'
import { Grid } from '@mui/material'
import axios from 'axios';
import { Constants } from '../../endPoints';
import { jwtDecode } from 'jwt-decode';

export default function Dashboard() {
  const [productCount, setProductCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      const decoded = jwtDecode(token);
      const idUser = decoded.id;
      fetchProductCount(idUser);
      fetchWishlistCount(idUser);
    }
  }, []);

  const fetchProductCount = async (idUser) => {
    try {
      const response = await axios.get(`${Constants.getProductCountByUser}/${idUser}`);
      if (response.data.status === 1) {
        setProductCount(response.data.total);
      }
    } catch (error) {
      console.error('Error fetching product count:', error);
    }
  };

  const fetchWishlistCount = async (idUser) => {
    try {
      const response = await axios.get(`${Constants.getUserWishlistCount}/${idUser}`);
      if (response.data.status === 1) {
        setWishlistCount(response.data.total);
      }
    } catch (error) {
      console.error('Error fetching wishlist count:', error);
    }
  };

  return (
    <>
    <Breadcumb pagetitle="Dashboard"/>
    <section className='py-12'>
      <div className='container mx-auto px-4'>
        <Grid container spacing={5}>
          <Grid item lg={3} md={12} sm={12} xs={12}>
            <DashboardNav/>
          </Grid>
          <Grid item lg={9} md={12} sm={12} xs={12}>
            <Grid container spacing={3}>
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <div className='text-center p-5 bg-[#b3902d] rounded-lg'>
                    <i class="fa-regular fa-suitcase text-5xl text-[#ffe18d]"></i>
                    <h2 className='my-3 text-4xl font-bold text-white'>{productCount}</h2>
                    <h3 className='mb-0 text-gray-50 text-base'>Listed Product</h3>
                </div>
              </Grid>
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <div className='text-center p-5 bg-[#b3902d] rounded-lg'>
                    <i class="fa-regular fa-heart  text-5xl text-[#ffe18d]"></i>
                    <h2 className='my-3 text-4xl font-bold text-white'>{wishlistCount}</h2>
                    <h3 className='mb-0 text-gray-50 text-base'>Saved Product</h3>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </section>
    </>
  )
}
